// features/findings/charts/causal-chain-diagram.js
// Causal-chain diagram — boxes and arrows showing mechanism steps.
// Each step has a confidence weight that sets the arrow thickness.

export function CausalChainDiagram({ title, steps }) {
  if (!steps || steps.length < 2) return null;

  return (
    <figure className="finding-chart">
      <figcaption className="finding-chart-caption">{title}</figcaption>
      <div className="finding-chain-wrap">
        {steps.map((step, i) => (
          <div key={i} className="finding-chain-step-row">
            <div className="finding-chain-step">
              <div className="finding-chain-step-num">{i + 1}</div>
              <div className="finding-chain-step-label">{step.label}</div>
            </div>
            {i < steps.length - 1 && (
              <div className="finding-chain-arrow">
                <ArrowDown
                  weight={steps[i].confidence ?? 0.7}
                  label={steps[i].edgeLabel}
                />
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="finding-chain-legend">
        Arrow thickness ∝ per-link evidence strength
      </div>
    </figure>
  );
}

function ArrowDown({ weight, label }) {
  const thickness = Math.max(1, Math.min(6, 1 + weight * 5));
  return (
    <div className="finding-chain-arrow-inner">
      <svg viewBox="0 0 40 40" width="40" height="40" className="finding-chain-arrow-svg">
        <line x1="20" y1="2" x2="20" y2="32" strokeWidth={thickness} className="finding-chain-arrow-line" />
        <polygon points="20,38 14,28 26,28" className="finding-chain-arrow-head" />
      </svg>
      {label && <div className="finding-chain-arrow-label">{label}</div>}
    </div>
  );
}

export default CausalChainDiagram;
